import {Mutation} from './mutation-types'
import axios from 'axios';
import {showWarning} from "../utils";
import {showCustomErrorSweetAlert,showCustomSuccessSweetAlert} from "../../utils";


export default {
    // Production Lines
    initializeProductionLines({commit, getters}, payload){
        return new Promise((resolve, reject) => {
            axios
            .get(`/api/production-line/allok`)
            .then( res => {
                // console.log('production Line Initialization Data', res)
                if(res.hasOwnProperty('data')){
                    res.data.forEach(function (productionLine, i) {
                        commit(Mutation.CREATE_PRODUCTION_LINE, {productionLine})
                    })
                    resolve(getters.productionLines);
                }else{
                    //ERROR AL OBTENER INFORMACION DE LAS LINEAS
                    showWarning('No se ha podido obtener la informacion de las lineas')
                    reject();
                }
            })
            .catch( error => {
                showCustomErrorSweetAlert(error.response.data);
                reject();
            })
        })
    },
    createProductionLine({commit}, linea) {
        return commit(Mutation.CREATE_PRODUCTION_LINE, linea)
    },

    //Stations
    createStation({commit}, payload) {
        return commit(Mutation.CREATE_STATION, payload)
    },

    //Machines
    createMachine({commit}, payload) {
        return commit(Mutation.CREATE_MACHINE, payload)
    },

    //Machine Operation Pivots
    createMachineOperationPivot({commit}, payload){
        commit(Mutation.CREATE_MACHINE_OPERATION_PIVOT, payload)
    },
    updateMachineOperationPivot({commit}, payload){
        commit(Mutation.UPDATE_MACHINE_OPERATION_PIVOT, payload)
    },
    deleteMachineOperationPivot({commit}, payload){
        commit(Mutation.DELETE_MACHINE_OPERATION_PIVOT, payload)
    },
    createOperationGroup({commit},payload) {
        return commit(Mutation.CREATE_OPERATION_GROUP, payload);
    },
    updateOperationGroup({commit},payload) {
        return commit(Mutation.UPDATE_OPERATION_GROUP, payload);
    },
    deleteOperationGroup({commit},payload) {
        return commit(Mutation.DELETE_OPERATION_GROUP, payload);
    },

    //Operations
    createOperation({commit},payload){
        return commit(Mutation.CREATE_OPERATION,payload)
    },
    updateOperation({commit},payload){
        return commit(Mutation.UPDATE_OPERATION,payload)
    },
    deleteOperation({commit},payload){
        return commit(Mutation.DELETE_OPERATION,payload)
    },
    createReferenceGroup({commit},payload) {
        return commit(Mutation.CREATE_REFERENCE_GROUP, payload);
    },
    updateReferenceGroup({commit},payload) {
        return commit(Mutation.UPDATE_REFERENCE_GROUP, payload);
    },
    deleteReferenceGroup({commit},payload) {
        return commit(Mutation.DELETE_REFERENCE_GROUP, payload);
    },
    createReference({commit},payload) {
        return commit(Mutation.CREATE_REFERENCE, payload);
    },
    updateReference({commit},payload) {
        return commit(Mutation.UPDATE_REFERENCE, payload);
    },
    deleteReference({commit},payload) {
        return commit(Mutation.DELETE_REFERENCE, payload);
    },
    createMagnitudeUnit({commit}, payload) {
        return commit(Mutation.CREATE_MAGNITUDE_UNIT, payload)
    },
    deleteMagnitudeUnit({commit}, payload) {
        return commit(Mutation.DELETE_MAGNITUDE_UNIT, payload)
    },

    //Packagings
    initializePackagings({commit, getters}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/packaging/all`)
            .then(res=> {
                if(res.hasOwnProperty('data')){
                    res.data.forEach(function (packaging, i) {
                        commit(Mutation.CREATE_PACKAGING, {packaging})
                    })
                    resolve(getters.packagings)
                }else{ //ERROR AL OBTENER INFORMACION DE LOS EMPAQUETADOS
                    showWarning('No se ha podido obtener la informacion de los empaquetados')
                    reject()
                }
            })
            .catch( err => {
                console.error(err)
                reject()
            })

        })
    },
    createPackaging({commit}, payload) {
        commit(Mutation.CREATE_PACKAGING, payload)
    },
    updatePackaging({commit}, payload) {
        commit(Mutation.UPDATE_PACKAGING, payload)
    },
    deletePackaging({commit}, payload) {
        commit(Mutation.DELETE_PACKAGING, payload)
    },

    //Packaging Formats
    initializePackagingFormats({commit, getters}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/packaging-format/all`)
            .then(res=> {
                if(res.hasOwnProperty('data')){
                    res.data.forEach(function (packagingFormat, i) {
                        commit(Mutation.CREATE_PACKAGING_FORMAT, {packagingFormat})
                    })
                    resolve(getters.packagingFormats)
                }else{ //ERROR AL OBTENER INFORMACION DE LOS EMPAQUETADOS
                    showWarning('No se ha podido obtener la informacion de los formatos de empaquetados')
                    reject()
                }
            })
            .catch( err => {
                console.error(err)
                reject()
            })

        })
    },
    createPackagingFormat({commit}, payload) {
        commit(Mutation.CREATE_PACKAGING_FORMAT, payload)
    },
    deletePackagingFormat({commit}, payload) {
        commit(Mutation.DELETE_PACKAGING_FORMAT, payload)
    },

    // User Permissions
    initializeUserPermissions({commit}, payload) {
        commit(Mutation.INITIALIZE_USER_PERMISSIONS, payload)
    },
    updateIsUserSuperadmin({commit}, payload) {
        commit(Mutation.UPDATE_IS_USER_SUPERADMIN, payload)
    },
    updateIsUserAdmin({commit}, payload) {
        commit(Mutation.UPDATE_IS_USER_ADMIN, payload)
    },
    updateUsername({commit}, payload) {
        commit(Mutation.UPDATE_USERNAME, payload)
    }
}
